export const numberToCurrency = (number: unknown, currency?: string) => {
  const num = Number(number);

  if (isNaN(num)) return `0 ${currency ?? ''}`.trimEnd();

  const formattedNumber = num % 1 === 0
      ? num.toLocaleString(undefined, { maximumFractionDigits: 0 })
      : num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return `${formattedNumber} ${currency ?? ''}`.trimEnd();
};
